import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccBondsRateCourt = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.BONDS_RATE_COURT',
  });
  return result;
};
